import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const giftCardPromoModalStyles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1000,
  } as CSSProperties,

  modal: {
    position: 'relative',
    width: '100%',
    maxHeight: '90vh',
    boxSizing: 'border-box',
    backgroundColor: theme.colors.background,
    borderTopLeftRadius: theme.radius.md,
    borderTopRightRadius: theme.radius.md,
    boxShadow: theme.shadows.md,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,

  content: {
    flex: 1,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.large,
    padding: `${theme.spacing.extraLarge}px 0 ${theme.spacing.medium}px`,
  } as CSSProperties,

  /** Ícono, título y subtítulo: bloque de 320 px centrado con 16 px entre elementos. */
  header: {
    width: 320,
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.medium,
  } as CSSProperties,

  icon: {} as CSSProperties,

  title: {
    margin: 0,
    textAlign: 'center',
    color: theme.colors.label,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.lg,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  description: {
    margin: 0,
    textAlign: 'center',
    color: theme.colors.palette.darkGrey200,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.base,
    fontWeight: theme.typography.fontWeight.normal,
  } as CSSProperties,

  section: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.medium,
    padding: `0 ${theme.spacing.medium}px`,
    boxSizing: 'border-box',
  } as CSSProperties,

  /** Píldora gris centrada (no ocupa todo el ancho). */
  helperText: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.tiny,
    padding: `${theme.spacing.tiny}px ${theme.spacing.extraSmall}px`,
    backgroundColor: theme.colors.palette.grey300,
    marginBottom: theme.spacing.small,
  } as CSSProperties,

  helperIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 16,
    height: 16,
    minWidth: 16,
    borderRadius: '50%',
    border: `1.5px solid ${theme.colors.subtitle}`,
    boxSizing: 'border-box',
    color: theme.colors.subtitle,
    fontSize: 10,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  helperTextLabel: {
    margin: 0,
    fontSize: theme.typography.fontSize.xs,
    lineHeight: theme.typography.lineHeight.sm,
    color: theme.colors.subtitle,
    fontFamily: theme.typography.fontFamily,
    whiteSpace: 'nowrap',
  } as CSSProperties,

  inputGroup: {
    width: '100%',
    display: 'flex',
    gap: theme.spacing.extraSmall,
  } as CSSProperties,

  input: {
    flex: 1,
    minWidth: 0,
    boxSizing: 'border-box',
    padding: `0 ${theme.spacing.extraSmall}px`,
    height: 40,
    border: `1px solid ${theme.colors.palette.grey300}`,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.inputBg,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    color: theme.colors.inputText,
    outline: 'none',
  } as CSSProperties,

  applyButton: {
    boxSizing: 'border-box',
    padding: `0 ${theme.spacing.medium}px`,
    height: 40,
    backgroundColor: theme.colors.white,
    color: theme.colors.button.primary,
    border: `1px solid ${theme.colors.button.primary}`,
    borderRadius: theme.radius.sm,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    alignItems: 'center',
    display: 'flex',
  } as CSSProperties,

  applyButtonHover: {
    backgroundColor: theme.colors.palette.lightBlue100,
  } as CSSProperties,

  /** Sin código ingresado (o con el máximo cargado): mismo botón al 60 % de opacidad, como en Figma. */
  applyButtonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  } as CSSProperties,

  errorBox: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing.small,
    padding: `${theme.spacing.mediumSmall}px ${theme.spacing.small}px`,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.palette.lightRed100,
  } as CSSProperties,

  errorIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    minWidth: 20,
    borderRadius: '50%',
    backgroundColor: theme.colors.palette.red100,
    color: theme.colors.white,
    fontSize: 12,
    fontWeight: theme.typography.fontWeight.bold,
    flexShrink: 0,
  } as CSSProperties,

  errorText: {
    margin: 0,
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.palette.darkGrey200,
    lineHeight: theme.typography.lineHeight.base,
  } as CSSProperties,

  codesList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.extraSmall,
  } as CSSProperties,

  codeItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    backgroundColor: theme.colors.palette.lightBlue100,
  } as CSSProperties,

  codeText: {
    margin: 0,
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.lg,
    fontWeight: theme.typography.fontWeight.normal,
    color: theme.colors.palette.blue300,
  } as CSSProperties,

  removeCodeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    lineHeight: 0,
  } as CSSProperties,

  footer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.extraSmall,
    padding: `${theme.spacing.extraSmall}px ${theme.spacing.medium}px`,
  } as CSSProperties,

  cancelButton: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    backgroundColor: theme.colors.white,
    color: theme.colors.button.primary,
    border: `1px solid ${theme.colors.button.primary}`,
    borderRadius: theme.radius.md,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
  } as CSSProperties,

  cancelButtonHover: {
    backgroundColor: theme.colors.palette.lightBlue100,
  } as CSSProperties,

  acceptButton: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    backgroundColor: theme.colors.button.primary,
    color: theme.colors.white,
    border: 'none',
    borderRadius: theme.radius.md,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
  } as CSSProperties,

  acceptButtonHover: {
    backgroundColor: theme.colors.button.primaryHover,
  } as CSSProperties,
} as const;
